var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(8.5 8.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.475,27.593l2.447-1.4a8.821,8.821,0,0,0,3.6,2.039V31h4.95V28.237a9,9,0,0,0,3.6-2.039l2.447,1.4L31,23.407l-2.447-1.368A8.29,8.29,0,0,0,28.8,20a8.451,8.451,0,0,0-.247-2.039L31,16.593l-2.475-4.185-2.447,1.4a8.821,8.821,0,0,0-3.6-2.039V9h-4.95v2.763a9,9,0,0,0-3.6,2.039l-2.447-1.4L9,16.593l2.447,1.368A8.29,8.29,0,0,0,11.2,20a8.451,8.451,0,0,0,.247,2.039L9,23.407ZM20,14.634A5.367,5.367,0,1,1,14.5,20,5.45,5.45,0,0,1,20,14.634Z",
    transform: "translate(-9 -9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSettingsIcon);
export default __webpack_public_path__ + "static/media/modalSettingsIcon.66ab6685.svg";
export { ForwardRef as ReactComponent };